import { isNil } from 'lodash';
import { MealPlanFormat, useGetNextUpcomingMealPlanGroupOrderQuery } from 'src/gqlReactTypings.generated.d';
import { useConsumerMealPlanStoreSelectors } from 'src/ztore/meal-plan-store';
import { LoadingScreenWithHeight } from 'web-common/src/shared/design-system/components/LoadingScreen';
import { ActiveSubscriberPage } from './ActiveSubscriberPage';

export const ActiveSubscriberPageWrapper: React.FC = () => {
  const { data } = useGetNextUpcomingMealPlanGroupOrderQuery();

  const groupOrders = data?.getUpcomingMealPlanGroupOrders?.groupOrders ?? [];
  const { getMealPlanType } = useConsumerMealPlanStoreSelectors();
  const mealPlanType = getMealPlanType();

  const groupOrder = groupOrders[0];
  const { mealPlanType: groupOrderMealPlanType } = groupOrder ?? {};
  const mealPlanTypeToUse = groupOrderMealPlanType ?? mealPlanType;

  if (isNil(groupOrder) || isNil(mealPlanTypeToUse)) {
    return <LoadingScreenWithHeight loadingMessage='Fetching your upcoming order' />;
  }

  return (
    <ActiveSubscriberPage
      groupOrder={groupOrders[0]}
      unit={mealPlanTypeToUse.unit}
      numServings={mealPlanTypeToUse.numServings}
      format={mealPlanTypeToUse.format ?? MealPlanFormat.MainsPlusSides}
    />
  );
};
